import script from "./AdBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdBlock.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./AdBlock.vue?vue&type=style&index=0&id=4c7261ba&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__